import { PoolConfig, QuoteToken, PoolCategory } from './types'

const pools: PoolConfig[] = [
  {
    sousId: 0,
    tokenName: 'DEF',
    tokenAddress: '0xC35786C9D727FCa19f17Ba78FC02B512482F8003',   // token address
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: '0xC35786C9D727FCa19f17Ba78FC02B512482F8003',  // token address
    contractAddress: {
      97: '',
      56: '0x39bAA8C574956b765427210C34fb5a669827f155',  /// masterchef address
    },
    poolCategory: PoolCategory.CORE,
    projectLink: '/',
    harvest: true,
    tokenPerBlock: '10',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
 
]

export default pools
